import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

const bedTypes: Record<string, string> = {
  short: 'short',
  regular: 'regular',
  chassis: 'chassis',
  stepSide: 'step_side',
  long: 'long',
};

export default function BedTypeTapEvent(label: string, sourcePage: SourcePages): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage === SourcePages.Srp ? SourcePages.SrpFilter : SourcePages.SeoSrpFilter,
    feature: Features.bedType,
    engagement_type: `${bedTypes[label]}_tap`,
    event_context: {},
  };
}
